export default __webpack_public_path__ + "static/media/swap.5003a5bc.png";